import React from 'react'

const InfoIcon = (props) => {
    return (
        <svg width="18" height="18" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(2.933 2.933)" stroke="var(--theme-color)" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="8.067" cy="8.067" r="8.067" />
                <path d="M8.059 4.033h.016M8.067 7.26v4.84" />
            </g>
        </svg>

    )
}

export default InfoIcon

